import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import DashboardHeader from "./DashboardHeader";
import DashboardSidebarLeft from "./DashboardSidebarLeft";
import DashboardSidebarRight from "./DashboardSidebarRight";

import "./dashboard.scss";

const Dashboard = () => {
  const [openSidebar, setOpenSidebar] = useState(false);

  return (
    <>
      <DashboardHeader  setOpenSidebar={setOpenSidebar}/>

      {openSidebar && (
        <div
          className="sidebar-overlay"
          onClick={() => setOpenSidebar(false)}
        ></div>
      )}

      
      <div style={{ display: "flex" }}>
       <div
  className={`sidebar-left ${openSidebar ? "show" : ""}`}
  style={{ position: "sticky", top: 80, height: "100vh" }}>
          <DashboardSidebarLeft 
           openSidebar={openSidebar}
        setOpenSidebar={setOpenSidebar}
          />
        </div>
       <div
  className="w-100 max-vh-100 min-vh-100 p-2 p-md-4"
  style={{ backgroundColor: "#E0E2EA" }}
>
          <Outlet />
        </div>
        {/* <div
          className="sidebar-right"
          style={{ position: "sticky", top: 76, height: "100vh" }}
        >
          <DashboardSidebarRight />
        </div> */}
      </div>
    </>
  );
};

export default Dashboard;
